const getItemLocalStorage = (item) => {
    let settings = null;
    try {
        const storedData = localStorage.getItem(item);
        if (storedData) {
            settings = JSON.parse(storedData);
        }
    }
    catch (err) {
        console.error(err);
    }
    return settings;
};

export { getItemLocalStorage };
